export const actionTypes = {
    CLOSE_FACETS_MENU: 'CLOSE_FACETS_MENU',
    CLOSE_MAIN_MENU: 'CLOSE_MAIN_MENU',
    FETCH_ALL_BRANDS: 'FETCH_ALL_BRANDS',
    FETCH_PLP_RESULTS: 'FETCH_PLP_RESULTS',
    OPEN_FACETS_MENU: 'OPEN_FACETS_MENU',
    OPEN_MAIN_MENU: 'OPEN_MAIN_MENU',
    UPDATE_PLP_ITEMS_PER_PAGE: 'UPDATE_PLP_ITEMS_PER_PAGE',
    UPDATE_PLP_PAGE: 'UPDATE_PLP_PAGE',
    UPDATE_PLP_REFINEMENTS: 'UPDATE_PLP_REFINEMENTS',
    UPDATE_PLP_SORT: 'UPDATE_PLP_SORT'
}